import * as jsondiffpatch from 'jsondiffpatch'

/**
 * Changes of the item's element since its element snapshot (`_elementData`) was
 * saved, undefined if the item is up to date. The snapshot is saved when a
 * template is unlinked (it no longer follows its element) and on upload; items
 * without one, e.g. linked templates, are never outdated.
 */
export const getElementDataDiff = (
  item: FileItem | SectionItem,
  currentElementData: Record<string, unknown>,
) => {
  if (item.type !== 'file' || !item.additional_data?._elementData) return undefined

  return jsondiffpatch.diff(item.additional_data._elementData, currentElementData)
}
